import { Phone, Siren } from "lucide-react";
import { BUSINESS } from "@/data/content";

export default function EmergencyBanner() {
  return (
    <section
      data-testid="emergency-banner"
      className="relative border-y border-[#E60000]/40 bg-[#E60000] overflow-hidden"
    >
      <div className="absolute inset-0 opacity-20 mix-blend-overlay pointer-events-none">
        <div
          className="w-full h-full"
          style={{
            backgroundImage:
              "repeating-linear-gradient(45deg, rgba(0,0,0,0.35) 0 2px, transparent 2px 14px)",
          }}
        />
      </div>
      <div className="relative mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16 py-14 md:py-20 grid md:grid-cols-12 gap-8 items-center">
        <div className="md:col-span-8">
          <div className="flex items-center gap-3 text-xs tracking-[0.24em] uppercase text-black/70 font-bold mb-4">
            <Siren className="w-4 h-4" strokeWidth={2.5} />
            Electrical emergency? Don&rsquo;t wait.
          </div>
          <h3 className="font-display text-3xl sm:text-4xl md:text-5xl tracking-tighter font-black leading-[0.95]">
            Sparking outlet, burning smell, dead panel —
            <br className="hidden md:block" />{" "}
            <span className="text-black">we roll trucks 24/7.</span>
          </h3>
          <p className="mt-4 text-sm md:text-base text-white/90 max-w-xl">
            Live dispatch across Vancouver &amp; the Lower Mainland. Average
            arrival time under 60 minutes in metro areas.
          </p>
        </div>
        <div className="md:col-span-4 flex md:justify-end">
          <a
            href={BUSINESS.phoneHref}
            data-testid="emergency-call-cta"
            className="inline-flex items-center gap-3 bg-[#0A0A0A] text-white hover:bg-black transition-colors font-bold px-6 py-5 group"
          >
            <span className="relative inline-flex w-10 h-10 bg-[#E60000] items-center justify-center">
              <Phone className="w-4 h-4" strokeWidth={2.5} />
              <span className="absolute inset-0 border border-white/40 animate-ping" />
            </span>
            <span className="flex flex-col text-left">
              <span className="text-[10px] tracking-[0.24em] uppercase text-white/50">
                24/7 Emergency Line
              </span>
              <span className="font-display text-xl md:text-2xl tracking-tight">
                {BUSINESS.phone}
              </span>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
